module.exports = __webpack_public_path__ + "img/slash-circle.95c5b7ef.svg";